import {Tooltip} from 'platform/components';
import {Box, Text, TextSize, ThemeColorTextPath} from 'platform/foundation';

import {useRef} from 'react';

import {TestIdProps, useIsTruncated} from 'shared/web';

interface TruncatedTextProps extends TestIdProps {
  value: string;
  size?: TextSize;
  color?: ThemeColorTextPath;
  isAlternative?: boolean;
}

/**
 * One line of plain, selectable text. A value too long for the line ends with an ellipsis and is
 * offered in full in a tooltip - only where it is actually cut.
 */
export function TruncatedText(props: TruncatedTextProps) {
  const textRef = useRef<HTMLDivElement>(null);
  const isTruncated = useIsTruncated(textRef, props.value);

  return (
    <Tooltip label={props.value} isDisabled={!isTruncated} placement="top">
      {/* Tooltip makes its wrapper a tab stop unless a child opts out: a cut value stays one, so
          keyboard users reach its full text too; a value shown in full is not interactive. */}
      <Box tabIndex={isTruncated ? undefined : -1} minWidth={0}>
        <Text
          ref={textRef}
          size={props.size ?? 'small'}
          color={props.color}
          alternative={props.isAlternative}
          noWrap
          data-testid={props['data-testid']}
        >
          {props.value}
        </Text>
      </Box>
    </Tooltip>
  );
}
